import React from 'react';
import { createRoot } from 'react-dom/client'; 
import { Provider } from 'react-redux';
import store from './store/store';
import App from './App';
import ErrorBoundary from '../components/ErrorBoundary';
import "@fortawesome/fontawesome-free/css/all.min.css";
import '../assets/styles/argon.css';
import '../assets/styles/app.css';
import '../assets/styles/ui-refresh.css';
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from '../helpers/authContext';
 
const container = document.getElementById('root');
const root = createRoot(container);
 
root.render(
  <Provider store={store}>
    <Router>
      <AuthProvider>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </AuthProvider>
    </Router>
  </Provider>
);
